import * as React from 'react';
import AutoLayout from '../../components/autolayout/AutoLayout';
/**
 * Wrap children in an AutoLayout component.
 *
 * @param {autolayout} {boolean}  Activate/deactivate the autolayouting mechanism.
 */
var AutoLayoutWrapper = function (_a) {
    var _b = _a.autolayout, autolayout = _b === void 0 ? true : _b, children = _a.children;
    if (autolayout === true) {
        return React.createElement(AutoLayout, null, children);
    }
    else if (autolayout) {
        return React.createElement(AutoLayout, { matrix: autolayout }, children);
    }
    else {
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return React.createElement(React.Fragment, null, children);
    }
};
export default AutoLayoutWrapper;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXV0b0xheW91dFdyYXBwZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9jb21wb25lbnRzL2F1dG9sYXlvdXQvQXV0b0xheW91dFdyYXBwZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sS0FBSyxLQUFLLE1BQU0sT0FBTyxDQUFBO0FBRTlCLE9BQU8sVUFBVSxNQUFNLG9DQUFvQyxDQUFBO0FBRzNEOzs7O0dBSUc7QUFDSCxJQUFNLGlCQUFpQixHQUdsQixVQUFDLEVBQStCO1FBQTdCLGtCQUFpQixFQUFqQixVQUFVLG1CQUFHLElBQUksS0FBQSxFQUFFLFFBQVEsY0FBQTtJQUNqQyxJQUFJLFVBQVUsS0FBSyxJQUFJLEVBQUU7UUFDdkIsT0FBTyxvQkFBQyxVQUFVLFFBQUUsUUFBUSxDQUFjLENBQUE7S0FDM0M7U0FBTSxJQUFJLFVBQVUsRUFBRTtRQUNyQixPQUFPLG9CQUFDLFVBQVUsSUFBQyxNQUFNLEVBQUUsVUFBVSxJQUFHLFFBQVEsQ0FBYyxDQUFBO0tBQy9EO1NBQU07UUFDTCx5REFBeUQ7UUFDekQsT0FBTywwQ0FBRyxRQUFRLENBQUksQ0FBQTtLQUN2QjtBQUNILENBQUMsQ0FBQTtBQUVELGVBQWUsaUJBQWlCLENBQUEifQ==